import Hero from "./HeroSection";
import { Helmet } from "react-helmet-async";
import FeeComparison from "./FeeComparisonSection";
import Globalbankaccounts from "./GlobalBankSection";
import Howitworks from "./HowItWorkSection";
import Majorplatform from "./MajorPlatformSection";
import Oneplatform from "./OnePlatformManageSection";
import Targetaudiences from "./TargetAudienceSection";
import Securitysection from "./Security&ComplianceSection";
import Cta from "./FooterCTA";
import Testimonial from "../TestimonialCarouselSection";
import Media from "../NewsCarouselSection";
import Investors from "../InvestorSection";
// import Banner from "../Banners/Banner";
// import Popup from "../Banners/popup";
import Accordion from "./FooterFAQ";
import { trackPageView } from "../../../utlis/useAnalytics";
import { useEffect } from "react";
import {PageName} from '../../../configs/config'


export default function Globalcollection() {

  useEffect(() => {
    trackPageView(PageName.GlobalCollection);
  }, []);

  
  return (
    <><Helmet>
      <title>Global Collection Account – Open Your Eximpe Account</title>
      <meta name="description" content="Discover Eximpe’s global collection of trade data, market analyses and insights—empowering you to make smarter import-export decisions." />
    </Helmet>
    <div className="overflow-y-hidden md:mt-[20px] overflow-x-hidden  mt-[100px]">

        {/* Banner Component */}
        {/* <Banner /> */}

        {/* Popup Component */}
        {/* <Popup /> */}

        {/* Hero Section */}
        <Hero />

        {/* Fees Comparison Section */}
        <FeeComparison />

        {/* Global Bank Accounts Section */}
        <Globalbankaccounts />

        {/* How It Works Section */}
        <Howitworks />

        {/* Major Platforms Section */}
        <Majorplatform />

        {/* One Platform Section */}
        <Oneplatform />

        {/* Target Audiences Section */}
        <Targetaudiences />

        {/* Security Section */}
        <Securitysection />

        {/* Testimonials and Media Section */}
        <div className="mt-[140px]">
          <Testimonial />

          <Media />
        </div>

        {/* Investors Section */}
        <div className="">
          <p className="text-4xl text-[#1A202C] mt-[140px] text-center font-bold mb-5">
            Our Investors are from
          </p>
          <Investors />
        </div>

        {/* FAQ Section */}
        <Accordion />

        {/* Footer Section */}
        <Cta />
      </div></>
  );
}
